/* Świat Gniotków – karta produktu na Dawn: galeria, pakiety z wyborem wersji, dodatki, dodawanie do koszyka (szuflada Dawn), sticky bar */
(function () {
  function fmt(cents, format) {
    format = format || '{{amount_with_comma_separator}} zł';
    var c = Math.round(cents);
    function num(n, dec, th, ds) {
      var str = (n / 100).toFixed(dec);
      var parts = str.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.length > 1 ? parts[0] + ds + parts[1] : parts[0];
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return num(c, 2, ',', '.');
        case 'amount_no_decimals': return num(c, 0, ',', '.');
        case 'amount_with_comma_separator': return num(c, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(c, 0, '.', ',');
        case 'amount_with_space_separator': return num(c, 2, ' ', ',');
        case 'amount_with_apostrophe_separator': return num(c, 2, "'", '.');
        default: return num(c, 2, ' ', ',');
      }
    });
  }

  function init(root) {
    if (!root || root.hasAttribute('data-sq-ready')) return;
    root.setAttribute('data-sq-ready', '1');
    var sid = root.getAttribute('data-sq-product');
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-sq-variants]').textContent); } catch (e) {}
    var money; try { money = JSON.parse(root.querySelector('[data-sq-money]').textContent); } catch (e) {}
    var byId = {}; variants.forEach(function (v) { byId[v.id] = v; });

    /* Galeria */
    var slides = root.querySelector('[data-sq-slides]');
    var dots = root.querySelectorAll('[data-sq-dots] button');
    var thumbs = root.querySelectorAll('[data-sq-thumbs] button');
    function goTo(i) {
      if (!slides || !slides.children[i]) return;
      slides.scrollTo({ left: slides.children[i].offsetLeft - slides.offsetLeft, behavior: 'smooth' });
    }
    function mark(i) {
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });
    thumbs.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });
    if (slides) {
      var t; slides.addEventListener('scroll', function () {
        clearTimeout(t); t = setTimeout(function () { mark(Math.round(slides.scrollLeft / slides.clientWidth)); }, 60);
      }, { passive: true });
    }
    function showMedia(mediaId) {
      if (!slides || !mediaId) return;
      var el = slides.querySelector('[data-sq-media="' + mediaId + '"]');
      if (el) goTo(Array.prototype.indexOf.call(slides.children, el));
    }

    /* Pakiety */
    var opts = root.querySelectorAll('[data-sq-opt]');
    var priceEl = root.querySelector('[data-sq-price]');
    var cmpEl = root.querySelector('[data-sq-compare]');
    var badgeEl = root.querySelector('[data-sq-badge]');
    var stickyPrice = document.querySelector('[data-sq-sticky="' + sid + '"] [data-sq-sticky-price]');
    var mainId = root.querySelector('[data-sq-main-id]');
    var mainQty = root.querySelector('[data-sq-main-qty]');
    var atc = root.querySelector('[data-sq-atc]');

    function activeOpt() { return root.querySelector('[data-sq-opt].is-active') || opts[0] || null; }
    function picks(opt) {
      if (!opt) return [mainId ? mainId.value : null];
      var sel = opt.querySelectorAll('[data-sq-pick]');
      var qty = parseInt(opt.getAttribute('data-sq-qty'), 10) || 1;
      if (!sel.length) { var a = []; for (var i = 0; i < qty; i++) a.push(mainId ? mainId.value : null); return a; }
      return Array.prototype.map.call(sel, function (s) { return s.value; });
    }
    function refreshOpt(opt) {
      var ids = picks(opt), disc = parseFloat(opt.getAttribute('data-sq-disc')) || 0;
      var full = 0, cmp = 0;
      ids.forEach(function (id) { var v = byId[id]; if (!v) return; full += v.price; cmp += (v.compare > v.price ? v.compare : v.price); });
      var total = Math.round(full * (100 - disc) / 100), saved = cmp - total;
      var p = opt.querySelector('[data-sq-opt-price]'), c = opt.querySelector('[data-sq-opt-compare]'), s = opt.querySelector('[data-sq-opt-save]');
      if (p) p.textContent = fmt(total, money);
      if (c) { c.textContent = fmt(cmp, money); c.hidden = saved <= 0; }
      if (s) { s.textContent = (s.getAttribute('data-sq-label') || '') + ' ' + fmt(saved, money); s.hidden = saved <= 0; }
    }
    function refreshMain() {
      var opt = activeOpt(); var ids = picks(opt); var first = byId[ids[0]] || variants[0];
      if (!first) return;
      if (mainId) mainId.value = first.id;
      if (mainQty) mainQty.value = ids.length;
      if (priceEl) priceEl.textContent = fmt(first.price, money);
      if (cmpEl) { cmpEl.textContent = fmt(first.compare, money); cmpEl.hidden = !(first.compare > first.price); }
      if (badgeEl) badgeEl.hidden = !(first.compare > first.price);
      if (stickyPrice) stickyPrice.textContent = fmt(first.price, money);
      var allOk = ids.every(function (id) { return byId[id] && byId[id].available; });
      if (atc) atc.disabled = !allOk;
      opts.forEach(refreshOpt);
    }
    opts.forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        if (e.target.closest('[data-sq-pick]')) return;
        opts.forEach(function (o) { o.classList.toggle('is-active', o === opt); var r = o.querySelector('input[type=radio]'); if (r) r.checked = o === opt; });
        refreshMain();
      });
      opt.querySelectorAll('[data-sq-pick]').forEach(function (sel) {
        sel.addEventListener('change', function () {
          var v = byId[sel.value]; if (v) showMedia(v.media);
          refreshMain();
        });
      });
    });

    /* Dodatki */
    root.querySelectorAll('[data-sq-up]').forEach(function (item) {
      var cb = item.querySelector('[data-sq-up-check]');
      cb.addEventListener('change', function () { item.classList.toggle('is-active', cb.checked); });
    });

    /* Dodaj do koszyka */
    var form = root.querySelector('[data-sq-buy]');
    var err = root.querySelector('[data-sq-err]');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atc.disabled) return;
      var counts = {};
      picks(activeOpt()).forEach(function (id) { if (id) counts[id] = (counts[id] || 0) + 1; });
      var items = Object.keys(counts).map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
      root.querySelectorAll('[data-sq-up]').forEach(function (item) {
        var cb = item.querySelector('[data-sq-up-check]'); var idEl = item.querySelector('[data-sq-up-id]');
        if (cb && cb.checked && idEl) items.push({ id: parseInt(idEl.value, 10), quantity: 1 });
      });
      var drawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer && drawer.getSectionsToRender) {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      atc.classList.add('is-loading'); atc.disabled = true;
      if (err) { err.classList.remove('is-on'); err.textContent = ''; }
      var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root_url + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { throw new Error(res.description || res.message || 'Nie udało się dodać do koszyka'); }
          if (drawer && res.sections && drawer.renderContents) {
            drawer.classList.contains('is-empty') && drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          } else {
            window.location.href = root_url + 'cart';
          }
        })
        .catch(function (ex) { if (err) { err.textContent = ex.message; err.classList.add('is-on'); } })
        .finally(function () { atc.classList.remove('is-loading'); atc.disabled = false; refreshMain(); });
    });

    /* Karuzela opinii */
    root.querySelectorAll('[data-sq-rc]').forEach(function (rc) {
      var track = rc.querySelector('.sq-rc__track'); var dw = rc.querySelector('[data-sq-rc-dots]');
      if (!track || !dw) return;
      var cards = track.children;
      if (cards.length < 2) { dw.style.display = 'none'; return; }
      for (var i = 0; i < cards.length; i++) {
        (function (k) {
          var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Opinia ' + (k + 1));
          if (k === 0) b.className = 'is-active';
          b.addEventListener('click', function () { track.scrollTo({ left: cards[k].offsetLeft - track.offsetLeft, behavior: 'smooth' }); });
          dw.appendChild(b);
        })(i);
      }
      track.addEventListener('scroll', function () {
        var k = Math.round(track.scrollLeft / track.clientWidth);
        Array.prototype.forEach.call(dw.children, function (d, j) { d.classList.toggle('is-active', j === k); });
      }, { passive: true });
    });

    /* Sticky bar */
    var sticky = document.querySelector('[data-sq-sticky="' + sid + '"]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      var footer = document.querySelector('footer, .footer');
      var atcVisible = true, footerVisible = false;
      function upd() {
        var on = !atcVisible && !footerVisible && atc.getBoundingClientRect().top < 0;
        sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        var btn = sticky.querySelector('[data-sq-sticky-btn]'); if (btn) btn.tabIndex = on ? 0 : -1;
      }
      new IntersectionObserver(function (en) { atcVisible = en[0].isIntersecting; upd(); }).observe(atc);
      if (footer) new IntersectionObserver(function (en) { footerVisible = en[0].isIntersecting; upd(); }).observe(footer);
      sticky.querySelector('[data-sq-sticky-btn]').addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else atc.click();
      });
    }

    refreshMain();
  }

  function all() { document.querySelectorAll('[data-sq-product]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
